import * as React from "react";
import { Button, IconButton, InputAdornment, InputLabel } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import {
  ButtonsContainer,
  ErrorText,
  FieldContainer,
  FormContainer,
} from "./CreateUserPopup.styled";
import InputField from "../../../components/formFields/InputField";
import { ModalWindow } from "../../../shared/components/modalWindow/ModalWindow";
import { useGetNaicMemberQuery, useGetMembersMutation } from "../../../services/InsuranceService";
import useFetchWithMsal from "../../../utils/useFetchWithMsal";
import SelectField from "../../../shared/components/SelectField";
import SearchableSelect from "../../../components/formFields/SearchableSelect";
import {
  useCreateUserMutation,
  useGetAssociationsQuery,
  useGetRolesQuery,
} from "../../../services/UserService";
import { generatePasswordAlphanumeric } from "../../../shared/utils/generatePassword";
import { LoadingPanel } from "../../../shared/components/LoadingPanel";
import { addMemberGroupColumns, memberColumns } from "../../../constants/TablesColumns";
import { useEffect, useState} from "react";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import StyledGrid, { FilterChip } from "../../../shared/components/StyledGrid";
import CheckboxField from "../../../components/formFields/CheckboxField";
import { TableFilter } from "./tableFilter/TableFilter";

export const CreateUserPopup = ({ open, onClose, data: initialData, addGroup, editGroup }) => {
  const dispatch = useDispatch();
  const transformedData = {
    groupName: initialData?.groupName,
    genericLogin: initialData?.genericLogin,
    active: initialData?.active === 'Yes' ? true : false,
    groupAccessCode: initialData?.groupAccessCode,
  };

  const initialValues = initialData ? transformedData : {
    groupName: "",
    genericLogin: "",
    active: false,
    groupAccessCode: generatePasswordAlphanumeric(),
  };

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 50,
  });
  const [totalCount, setTotalCount] = useState(0);

  const isFirstVisit = useSelector((state) => state.firstVisit.isFirstVisit);


  const roleId = useSelector((state) => state?.user?.roleId);

  const [sortingModel, setSortingModel] = useState();
  const [selectedMembers, setSelectedMembers] = useState(initialData?.members);

  const { skip } = useFetchWithMsal();
  const [getMembers, { data, isLoading }] = useGetMembersMutation("", { skip });
  const navigate = useNavigate();
  const { naicCode, memberName, memberEmail } = useSelector(
    (state) => state.filter
  );

  useEffect(() => {
    if(!skip){
      fetchData()
    }
  }, [
    paginationModel.page,
    paginationModel.pageSize,
    sortingModel?.field,
    sortingModel?.sort,
    initialData,
    skip
  ]);

  useEffect(() => {
    setSelectedMembers(initialData?.members)
  }, [initialData]);

  useEffect(() => {
    !open && setSelectedMembers([])
  }, [open]);

  

  useEffect(() => {
    if (!isLoading) {
      if (data?.totalCount !== totalCount) {
        setTotalCount(data?.totalCount);
      }
    }
  }, [isLoading]);

  useEffect(() => {
    if (!isLoading) {
      if (data?.totalCount !== totalCount) {
        setTotalCount(data?.totalCount);
      }
    }
  }, [isLoading]);

  const fetchData = (value) => {
    const body = {
      page: paginationModel.page + 1,
      pageSize: paginationModel.pageSize,
      orderBy: sortingModel?.field || "",
      orderByDirection: sortingModel?.sort || "",
      email: value ? value.memberEmail : memberEmail,
      naicCode: value ? value.naicCode : naicCode,
      memberName: value ? value.memberName : memberName,
      groupId: initialData?.groupId,
    };
    getMembers(body);
  };
  
  const handlePaginationModelChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
  };
  const onAddMemberClick = () => {
    navigate("/createMember");
  };
  const onApplyFilters = (value) => {
    if(paginationModel.page){
      setPaginationModel(prev => { return {...prev, page:0}})

    } else {
      !skip && fetchData(value)
    }

    // getClients({
    //   recordNumber: page * rowsPerPage,
    //   offset: rowsPerPage,
    //   status: resetFilter === 'status' ? '' : status,
    //   counselor: resetFilter === 'counselor' ? '' : counselor,
    //   housing: resetFilter === 'housing' ? '' : housing
    // })
  };
  const { data: naicMembers } = useGetNaicMemberQuery("", {});
  const { data: roles } = useGetRolesQuery("", {
    skip,
  });
  const { data: associations } = useGetAssociationsQuery("", {
    skip,
  });
  const [createUser, {isSuccess,error}] = useCreateUserMutation();

  useEffect(()=>{
    if(isSuccess){
      onClose()
    }
  },[isSuccess])

  const handleSelectionChange = (newSelection) => {
    setSelectedMembers(newSelection);
  };

  const validationSchema = Yup.object().shape({
    groupName: Yup.string().required("Group Name is required"),
    groupAccessCode: Yup.string().required("Access Code is required"),
    genericLogin: Yup.string().required("Generic Login is required"),
  });
  const handleSubmit = (values) => {
    initialData 
      ? editGroup({...values, members: selectedMembers, active: values?.active ? "Yes" : "No", id: initialData?.groupId, accessCode: values?.groupAccessCode})
      : addGroup({...values, members: selectedMembers, active: values?.active ? "Yes" : "No", accessCode: values?.groupAccessCode});
  };

  const copyToClipboard = (value) => {
    if (navigator?.clipboard) {
      navigator?.clipboard.writeText(value);
    }
  };

  const getInputComponent = (item, values) => {
    switch (item?.type) {
      case "searchableSelect":
        return (
          <FieldContainer>
            <SearchableSelect
              name={item.name}
              label={item.label}
              fullWidth
              multiline
              options={naicMembers?.slice(1)}
            />
          </FieldContainer>
        );
      case "select":
        return (
          <FieldContainer>
            <SelectField
              name={item.name}
              label={item.label}
              data={item.data}
              fullWidth
            />
          </FieldContainer>
        );
      case "checkbox":
        return (
          <FieldContainer>
            <CheckboxField name={item.name} label={item.label} fullWidth isDisabled={item.isDisabled}/>
          </FieldContainer>
        );
      case "password":
        return (
          <FieldContainer>
            <InputField
              name={item.name}
              label={item.label}
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                     <IconButton
                      onClick={() => item.setValue(item.name, generatePasswordAlphanumeric())}
                    >
                      <AutorenewIcon />
                    </IconButton>
                    <IconButton
                      onClick={() => copyToClipboard(item.value)}
                    >
                      <ContentCopyIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </FieldContainer>
        );
      default:
        return (
          <FieldContainer>
            <InputField name={item.name} label={item.label} fullWidth />
          </FieldContainer>
        );
    }
  };
  return (
    <ModalWindow open={open} onClose={onClose} header={initialData ? "Edit Group" : "Add Group"}>
     {isLoading && <LoadingPanel />}
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        {({ values, setFieldValue }) => (
          <Form id={"memberForm"}>
            <FormContainer>
            <ErrorText type='error'>{error?.data?.Message}</ErrorText>

              {getInputComponent({
                name: "groupName",
                label: "Group Name:",
                type: "text",
              })}
              {getInputComponent({
                name: "active",
                label: "Active",
                type: "checkbox",
              })}
              {getInputComponent({
                name: "genericLogin",
                label: "Generic Login:",
                type: "text",
              })}
              {getInputComponent({
                name: "groupCode",
                label: "Group Code:",
                type: "text",
              })}
              {getInputComponent({
                name: "groupAccessCode",
                label: "Access Code :",
                type: "password",
                value: values.groupAccessCode,
                setValue:setFieldValue
              })}
              <InputLabel htmlFor="input" sx={{ height: "14px", marginBottom: "10px", marginRight: "auto", marginLeft: "25px", marginTop: '5px' }}>
                Members:
              </InputLabel>
              <Box display={"flex"} sx={{ width: "100%", justifyContent: "flex-end" }} mb={3}>
                <TableFilter onApplyFilters={onApplyFilters}/>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  flexWrap: "wrap",
                  alignItems: "center",
                  marginRight: "auto",
                  marginLeft: "25px",
                  marginBottom: "15px",
                }}
              >
                {naicCode && <FilterChip>NAIC Code: {naicCode}</FilterChip>}
                {memberName && <FilterChip>Member Name: {memberName}</FilterChip>}
                {memberEmail && <FilterChip>Member Email: {memberEmail}</FilterChip>}
              </Box>
              <StyledGrid
                data={data?.members}
                width="800px"
                height="400px"
                overflow="auto"
                columns={addMemberGroupColumns}
                rowCount={totalCount}
                withFilter
                withCheckboxSelection
                onSortingModelChange={(model) => setSortingModel(model[0])}
                paginationModel={paginationModel}
                setPaginationModel={handlePaginationModelChange}
                onRowSelectionModelChange={handleSelectionChange}
                selectionModel={selectedMembers}
                hideFooterSelectedRowCount={false}
              />
            </FormContainer>
            <ButtonsContainer>
              <Button variant="outlined" type="submit">
                Save
              </Button>
              <Button variant="outlined" onClick={() => onClose()}>
                Cancel
              </Button>
            </ButtonsContainer>
          </Form>
        )}
      </Formik>
    </ModalWindow>
  );
};
